import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import { PriceFormats, SummaryColumns } from "@repo/utils";
import { MAX_VALUES } from "@utils";
import {
  useEstimateStructure,
  useSummaryUnitCostInputTooltipAlert,
  useVisibilityModeCellClassName,
  useEstimateEditorSettings,
  ValueCell,
} from "@tools";

export const RateCell = observer(({
  element,
  displayClientCellContent,
  displayCellContent,
  ...props
}) => {
  const structure = useEstimateStructure();
  const { allowEdition, useProfitability } = useEstimateEditorSettings();
  const tooltip = useSummaryUnitCostInputTooltipAlert(useProfitability, element.hasFixedPrice);
  const className = useVisibilityModeCellClassName(structure.visibility.hideSummaryRate);
  
  const { displayAnyValue } = structure;
  const { currencyObj, modifier, timeModifier, priceFormat } = structure.settings;
  const { displayRate, hasResources, hasFixedPrice } = element;
  
  const handleRateChange = (rate) => {
    element.setRate(rate / modifier);//, allowInteractions && isProposal);
  };

  return (
    <ValueCell
      colName={ SummaryColumns.RATE }
      useDynamicWidth
      showDecimals
      fullWidthInputs
      emptyInputs={hasFixedPrice || !displayAnyValue}
      value={displayRate}
      displayContent={useProfitability ? displayCellContent : displayClientCellContent}
      onValueChange={handleRateChange}
      editable={!hasResources && allowEdition}
      max={timeModifier === 1 ? MAX_VALUES.RATE_HOUR : MAX_VALUES.RATE_DAY}
      symbolStart={currencyObj.symbolStart}
      symbolEnd={currencyObj.symbolEnd}
      americanFormat={priceFormat === PriceFormats.AMERICAN}
      useSeparator={useProfitability}
      className={className}
      textPresetClass="preset-summaryText"
      inputClassName="input-rate"
      applySuffixSpacing
      { ...props }
      { ...tooltip }
    />
  );
});

RateCell.propTypes = {
  element: object.isRequired,
  displayClientCellContent: bool,
  displayCellContent: bool,
  extendPadding: bool,
};
